import styled, { css } from "styled-components";

/**
 * Grille responsive : `cols` = 2 | 3 | 4.
 * 980px → 2 colonnes, 620px → 1 colonne.
 */
export const Grid = styled.div`
    display: grid;
    gap: var(--prh-space-md);
    grid-template-columns: repeat(${({ cols = 3 }) => cols}, 1fr);
    ${({ $mb }) =>
        $mb &&
        css`
            margin-bottom: var(--prh-space-md);
        `}
    ${({ $mt }) =>
        $mt &&
        css`
            margin-top: var(--prh-space-md);
        `}

    @media (max-width: 980px) {
        ${({ cols }) =>
            cols >= 3 &&
            css`
                grid-template-columns: repeat(2, 1fr);
            `}
    }
    @media (max-width: 620px) {
        grid-template-columns: 1fr;
    }
`;

/** Pile verticale de cartes (dans une colonne de grille) */
export const Stack = styled.div`
    display: grid;
    gap: var(--prh-space-md);
    align-content: start;
`;
